import landmarkSchema from '../api/landmark.graphql';
import { useLazyQuery, useResult } from '@vue/apollo-composable';
import { prepareObject } from '@/provider/utils';
import { mediaClient } from '@/provider';

export function useLandmark(landmarkId) {
  const { result, load, loading } = useLazyQuery(
    landmarkSchema.fetch,
    {
      id: landmarkId
    },
    {
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-only'
    }
  );

  const item = useResult(result, {}, data => {
    const preparedObject = prepareObject(data.object);
    return {
      ...preparedObject,
      radius: preparedObject.positionRadius.value,
      center: [
        preparedObject.positionCenter.value.lon,
        preparedObject.positionCenter.value.lat
      ],
      color: preparedObject.infoColor.value,
      url: mediaClient.getImageUrl(preparedObject.infoImageId.value)
    };
  });

  return {
    load,
    item,
    loading
  };
}
